import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ShieldCheck, GraduationCap, Hourglass, XCircle } from 'lucide-react';
import { SalesKycForm } from '@/components/sales/onboarding/SalesKycForm';
import { SalesExam } from '@/components/sales/onboarding/SalesExam';

function Step({ n, title, icon: Icon, done, children, testid }) {
  return (
    <Card className="border border-brand-border bg-white" data-testid={testid}>
      <CardContent className="p-6 space-y-4">
        <div className="flex items-center gap-3">
          <div className={`w-9 h-9 rounded-full flex items-center justify-center ${done ? 'bg-emerald-100 text-emerald-700' : 'bg-blue-50 text-brand-primary'}`}><Icon size={17} /></div>
          <h3 className="font-heading font-bold text-brand-text-primary">Step {n} · {title}</h3>
          {done && <Badge className="border-0 bg-emerald-100 text-emerald-700 text-[11px] ml-auto">Done</Badge>}
        </div>
        {children}
      </CardContent>
    </Card>
  );
}

export function SalesOnboarding({ status, onChange }) {
  const kycDone = ['submitted', 'approved'].includes(status.kyc?.status);
  const s = status.onboarding_status;
  return (
    <div className="space-y-5" data-testid="sales-onboarding">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-brand-text-primary tracking-tight">Get Verified</h1>
        <p className="text-sm text-brand-text-secondary mt-1">Complete your KYC and pass the exam. Your dashboard opens after admin approval.</p>
      </div>
      {s === 'rejected' && (
        <div className="flex items-start gap-2 p-4 rounded-lg bg-rose-50 border border-rose-200 text-sm text-rose-800" data-testid="onboarding-rejected">
          <XCircle size={17} className="mt-0.5" /> <div><b>Your application was rejected.</b> {status.review_notes} Please correct your KYC and submit again.</div>
        </div>
      )}
      {s === 'under_review' && (
        <div className="flex items-center gap-2 p-4 rounded-lg bg-amber-50 border border-amber-200 text-sm text-amber-800" data-testid="onboarding-under-review">
          <Hourglass size={17} /> KYC submitted and exam passed. Waiting for admin approval.
        </div>
      )}
      <Step n={1} title="KYC Verification" icon={ShieldCheck} done={kycDone && s !== 'rejected'} testid="onboarding-step-kyc">
        {kycDone && s !== 'rejected' ? <p className="text-sm text-brand-text-secondary">KYC submitted on {status.kyc.submitted_at?.slice(0, 10)}.</p>
          : <SalesKycForm kyc={status.kyc} onSubmitted={onChange} />}
      </Step>
      <Step n={2} title="Sales Exam (30 questions)" icon={GraduationCap} done={status.exam.passed} testid="onboarding-step-exam">
        <SalesExam exam={status.exam} onFinished={onChange} />
      </Step>
    </div>
  );
}
